module.exports = "<ion-view\r\n  class=\"wizard\"\r\n  title=\"{{'onboarding.invite.accepted.header' | translate}}\"\r\n  cache-view=\"false\">\r\n  <div class=\"wizard setup-section setup-complete\">\r\n    <div translate=\"onboarding.success\"></div>\r\n    <div class=\"title\" translate=\"onboarding.invite.accepted.message\"></div>\r\n    <div class=\"login\" ui-sref=\"app.navigation-orgs-list\">\r\n      <div translate=\"onboarding.go.home\"></div>\r\n      <i class=\"icon ion-ios-arrow-forward\"></i>\r\n    </div>\r\n  </div>\r\n</ion-view>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/auth/controllers/complete-org-invite-accepted.html
// module id = 2280
// module chunks = 0